import { Component, OnInit, AfterViewInit, Inject, Output, EventEmitter } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { DbService } from '../core/services/db.service';
import { AuthService } from '../core/services/auth.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  configData;
  openSwitch = false;

  //TODO 사이드 메뉴 리스트 넣기
  menu = [
    {
      label: '대시보드',
      icon: 'bx-home',
      link: '/dashboard',
    },
    {
      label: '회원 관리',
      icon: 'bx-user',
      link: '/user-list',
    },
    {
      label: '커뮤니티 관리',
      icon: 'bx-list-ul',
      subItems: [
        {
          label: '카테고리 관리',
          link: '/category-list',
        },
        {
          label: '게시글 관리',
          link: '/post-list',
        },
        {
          label: '홈 메인글 관리',
          link: '/home-main-manage',
        },
        {
          label: '댓글 신고 관리',
          link: '/comment-report-list',
        },
      ],
    },

    {
      label: '서비스/정보관리',
      icon: 'bx-note',
      subItems: [
        {
          label: '팝업 관리',
          link: '/popup-manage',
        },
        {
          label: '공지사항',
          link: '/notice',
        },
        {
          label: '개인정보/서비스 이용약관',
          link: '/terms',
        },
      ],
    },
  ];

  routerUrl: string;

  constructor(
    // private eventService: EventService,
    private router: Router,
    @Inject(DOCUMENT) private document: any,
    private db: DbService,
    private auth: AuthService
  ) {
    router.events.forEach(event => {
      if (event instanceof NavigationEnd) {
        // this._activateMenuDropdown();
        this.routerUrl = event.url;
      }
    });
  }

  ngOnInit() {
    //사이드바 정의
    document.body.setAttribute('data-sidebar', 'dark');
    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };
  }

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  isCondensed = false;

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    this.onSettingsButtonClicked();
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');

    if (window.screen.width <= 768) {
      document.body.classList.remove('vertical-collpsed');
    }
  }

  ngAfterViewInit() {
    // this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  scrollable() {
    document.body.setAttribute('data-layout-scrollable', 'true');
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    // this.mobileMenuButtonClicked.emit();
    this.onToggleMobileMenu();
  }

  /**
   * Logout the user
   */
  logout() {
    this.auth.logoutUser().then(() => {
      localStorage.removeItem('adminInfo');
      this.router.navigate(['/account/login']);
    });
  }

  public hide() {
    document.body.classList.remove('right-bar-enabled');
  }

  open(list, menu, mi) {
    const activeTag = document.querySelector<HTMLElement>('.active');
    if (activeTag) {
      activeTag.classList.remove('active');
    }
    if (list.openSwitch) {
      console.log('close');
      list.openSwitch = false;
    } else {
      list.openSwitch = true;
      menu.forEach(ele => {
        if (ele != list && ele.openSwitch == true) {
          ele.openSwitch = false;
        }
      });

      if (list.subItems && list.subItems.length > 0) {
        for (let index = 0; index < list.subItems.length; index++) {
          const element = list.subItems[index];

          if (element.link == this.routerUrl) {
            const aTag = document.querySelector<HTMLElement>(`.atag${mi}${index}`);
            aTag.classList.add('active');
          }
        }
      }
    }
  }

  close(aTag: HTMLElement) {
    aTag.classList.add('active');
    this.menu.forEach((ele: any) => {
      ele.openSwitch = false;
    });
  }

  //클릭시 active class
  // _activateMenuDropdown() {
  //   this._removeAllClass('mm-active');
  //   this._removeAllClass('mm-show');
  //   const links = document.getElementsByClassName('side-nav-link-ref');
  //   let menuItemEl = null;
  //   // tslint:disable-next-line: prefer-for-of
  //   const paths = [];
  //   for (let i = 0; i < links.length; i++) {
  //     paths.push(links[i]['pathname']);
  //   }
  //   var itemIndex = paths.indexOf(window.location.pathname);
  //   if (itemIndex === -1) {
  //     const strIndex = window.location.pathname.lastIndexOf('/');
  //     const item = window.location.pathname.substr(0, strIndex).toString();
  //     menuItemEl = links[paths.indexOf(item)];
  //   } else {
  //     menuItemEl = links[itemIndex];
  //   }
  //   if (menuItemEl) {
  //     menuItemEl.classList.add('active');
  //     const parentEl = menuItemEl.parentElement;
  //     if (parentEl) {
  //       parentEl.classList.add('mm-active');
  //       const parent2El = parentEl.parentElement.closest('ul');
  //       if (parent2El && parent2El.id !== 'side-menu') {
  //         parent2El.classList.add('mm-show');
  //         const parent3El = parent2El.parentElement;
  //         if (parent3El && parent3El.id !== 'side-menu') {
  //           parent3El.classList.add('mm-active');
  //           const childAnchor = parent3El.querySelector('.has-arrow');
  //           const childDropdown = parent3El.querySelector('.has-dropdown');
  //           if (childAnchor) {
  //             childAnchor.classList.add('mm-active');
  //           }
  //           if (childDropdown) {
  //             childDropdown.classList.add('mm-active');
  //           }
  //           const parent4El = parent3El.parentElement;
  //           if (parent4El && parent4El.id !== 'side-menu') {
  //             parent4El.classList.add('mm-show');
  //             const parent5El = parent4El.parentElement;
  //             if (parent5El && parent5El.id !== 'side-menu') {
  //               parent5El.classList.add('mm-active');
  //               const childanchor = parent5El.querySelector('.is-parent');
  //               if (childanchor && parent5El.id !== 'side-menu') {
  //                 childanchor.classList.add('mm-active');
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // }

  // // 메뉴 클릭시 다른주소 remove class
  // _removeAllClass(className) {
  //   const els = document.getElementsByClassName(className);
  //   while (els[0]) {
  //     els[0].classList.remove(className);
  //   }
  // }
}
